import React, {Fragment} from 'react';
import {Helmet} from 'react-helmet';

export const ArticleSchema = (props) => {
    const {
        datePublishedCustom,
        sys,
        heroFile,
        systemData: {hostname, humanReadableName, siteName},
        headline,
    } = props;
    const brandName = humanReadableName.split('.')[0] || humanReadableName;
    const logoUrl = `https://csvcus.homeaway.com/rsrcs/cdn-logos/3.4.0/bce/moniker/${siteName}/logo-bceheader.png`;

    return (
        <Fragment>
            <Helmet>
                <script type="application/ld+json">
                    {`{
                        "@context": "http://schema.org",
                        "@type": "Article",
                        "datePublished": "${datePublishedCustom}",
                        "dateModified": "${sys.publishedAt}",
                        "headline": "${headline}",
                        "author": {
                            "@type": "Organization",
                            "name": "${humanReadableName}"
                        },
                        "publisher": {
                            "@type": "Organization",
                            "name": "${humanReadableName}",
                            "logo": "${logoUrl}"
                        },
                        ${heroFile && `"image": "${heroFile.url}"`}
                    }`}
                </script>
            </Helmet>
            <meta itemProp="genre" content="travel" />
            <div
                itemProp="publisher"
                itemScope
                itemType="https://schema.org/Organization"
            >
                <meta itemProp="name" content={brandName} />
                <div
                    itemProp="logo"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                >
                    <meta itemProp="url" content={logoUrl} />
                    <meta itemProp="width" content="125" />
                    <meta itemProp="height" content="40" />
                </div>

                <link itemProp="sameAs" href={`https://${hostname}`} />
            </div>
            <span
                itemProp="author"
                itemScope
                itemType="http://schema.org/Organization"
            >
                <meta itemProp="name" content={brandName} />
            </span>
            <meta itemProp="datePublished" content={datePublishedCustom} />
            <meta itemProp="dateModified" content={sys.publishedAt} />
        </Fragment>
    );
};

export default ArticleSchema;
